import './_latest-news-styles.scss';
import './latest-news';
